import axios, { AxiosError, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { LocalStorageService } from './local-storage.service';
import { ApiRoutesConfig } from '../config';
import { AuthToken } from '../features/auth';
// import store from '../stores/store';

export const baseURL = process.env.REACT_APP_API_URL;

const apiRoutes = new ApiRoutesConfig();

export const api: AxiosInstance = axios.create({
  baseURL,
  // timeout: 10000,
});

// Флаг для отслеживания процесса обновления токена
let isRefreshing = false;
// Массив запросов, которые ожидают обновления токена
let failedQueue: Array<{
  resolve: (value?: any) => void;
  reject: (error: any) => void;
}> = [];

// Функция для обработки очереди запросов
const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(prom => {
    if (token) {
      prom.resolve(token);
    } else {
      prom.reject(error);
    }
  });

  failedQueue = [];
};

// const userStore = store?.user;

// Добавляем интерсептор запроса
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    // Пытаемся получить токен
    const token: AuthToken | null = LocalStorageService?.getToken();

    if (token) {
      // Добавляем токен в заголовки запроса
      config.headers['Authorization'] = `Bearer ${token.accessToken}`;
    }

    return config;
  },
  (error: AxiosError): Promise<never> => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    return response;
  },
  async (error: AxiosError): Promise<any> => {
    const originalRequest = error.config as InternalAxiosRequestConfig & {
      _retry?: boolean;
    };
    console.log(error.response?.status);
    // Проверяем, является ли ошибка связанной с истекшим токеном
    if (error.response?.status === 401 && !originalRequest._retry) {
      // Пытаемся получить токен
      const token: AuthToken | null = LocalStorageService?.getToken();

      if (token?.refreshToken) {
        if (isRefreshing) {
          // Если уже идет процесс обновления токена, ждем его завершения
          try {
            const newToken = await new Promise<string>((resolve, reject) => {
              failedQueue.push({ resolve, reject });
            });
            originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
            return api(originalRequest);
          } catch (err) {
            return Promise.reject(err);
          }
        }

        originalRequest._retry = true;
        isRefreshing = true;

        try {
          // Пытаемся обновить токен
          // await store.auth.refresh();

          const response = await post(apiRoutes.refresh, {
            refreshToken: token?.refreshToken,
          });
          if (response.status === 200) {
            LocalStorageService.setToken(response.data.token);
          }

          // Обрабатываем очередь запросов
          processQueue(null, response.data.token?.accessToken);

          // Повторяем оригинальный запрос с новым токеном
          originalRequest.headers['Authorization'] = `Bearer ${response.data.token?.accessToken}`;
          return api(originalRequest);
        } catch (err) {
          // Если обновление токена не удалось, перенаправляем пользователя на страницу входа
          processQueue(err, null);
          LocalStorageService.clearToken();
          // store.auth.logout(); // Предполагается, что у вас есть метод для выхода пользователя
          return Promise.reject(err);
        } finally {
          isRefreshing = false;
        }
      } else {
        // Если нет refreshToken, перенаправляем пользователя на страницу входа
        // store.auth.logout(); // Предполагается, что у вас есть метод для выхода пользователя
        LocalStorageService.clearToken();
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  },
);

export default api;

export function put<T = any>(url: string, data?: T) {
  // if (data) {this.filterParams(data);}

  return api.put(url, data);
}

export function del<T = any>(url: string, data?: T) {
  // if (data) {this.filterParams(data);}

  return api.delete(url, { data });
}

export function post<T = any>(url: string, data?: T) {
  // if (data) {this.filterParams(data);}

  return api.post(url, data);
}

export function get<T = any>(url: string, params?: T) {
  // if (params) {this.filterParams(params);}

  return api.get(url, { params });
}

export class RequestService {
  public put<T = any>(url: string, data?: T) {
    // if (data) {this.filterParams(data);}

    return api.put(url, data);
  }

  public del<T = any>(url: string, data?: T) {
    // if (data) {this.filterParams(data);}

    return api.delete(url, { data });
  }

  public post<T = any>(url: string, data?: T) {
    // if (data) {this.filterParams(data);}

    return api.post(url, data);
  }

  public get<T = any>(url: string, params?: T) {
    // if (params) {this.filterParams(params);}

    return api.get(url, { params });
  }
}

export const requestService = new RequestService();
// export default requestService;

// export const notNull = (val: any) => {
//   return val !== null && val !== undefined;
// };

// export function put(url: string, data?: any) {
//   return serviceSend({
//     url,
//     params: { ...data, filter: false },
//     method: 'put',
//   });
// }

// export function deletes(url: string, data?: any) {
//   return serviceSend({ url, params: { params: data }, method: 'delete' });
// }

// export function post(url: string, data?: any) {
//   return serviceSend({ url, params: data || {} });
// }

// export function get(url: string, params?: any) {
//   return serviceSend({ url, params: params || {}, method: 'get' });
// }

// function serviceSend({ url, params = {}, method = 'post' }: any) {
//   const { filter = true, ...reset } = params ?? {};
//   filter && filterParams(reset);

//   return new Promise((resolve, reject) => {
//     api[method](url, reset)
//       .then((res: any) => {
//         if (notNull(res.data)) {
//           resolve(res.data);
//         } else {
//           resolve(res);
//         }
//       })
//       .catch((error: any) => {
//         reject(error);
//       });
//   });
// }

// function filterParams(params: any) {
//   for (const key in params) {
//     const val = params[key];
//     if (
//       Object.prototype.toString.call(val) === '[object Object]' ||
//       Object.prototype.toString.call(val) === '[object Array]'
//     ) {
//       filterParams(val);
//     } else if (
//       Object.prototype.toString.call(val) === '[object Null]' ||
//       Object.prototype.toString.call(val) === '[object Undefined]' ||
//       (Object.prototype.toString.call(val) === '[object String]' &&
//         val.trim() === '')
//     ) {
//       delete params[key];
//     }
//   }
// }

// class RequestService {
//   private service: AxiosInstance;
// private userStore: UserStore;

// constructor() {
//   // this.userStore = rootStore.user;
//   this.service = axios.create({
//     baseURL,
//     timeout: 10000,
//   });

// Добавляем интерсептор запроса
// this.service.interceptors.request.use(
//   (config) => {
//     // Пытаемся получить токен

//     const token: AuthToken | null = this.userStore.data.token || LocalStorageService?.getToken();

//     if (token) {
//       // Добавляем токен в заголовки запроса
//       config.headers['Authorization'] = `Bearer ${token.accessToken}`;
//     }

//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

//   this.service.interceptors.request.use(
//     (config: AxiosRequestConfig) => {
//       const token = LocalStorageService.getToken();
//       if (token && config.headers) {
//         config.headers.Authorization = `Bearer ${token}`;
//       }

//       return config;
//     },
//     (error) => {
//       return Promise.reject(error);
//     }
//   );

//   this.service.interceptors.response.use(
//     (response: AxiosResponse) => {
//       return response.data;
//     },
//     (error) => {
//       if (error.response?.status === 401) {
//         alert('Token expired, please log in again.');
//         Router.push('/login');
//       } else {
//         alert(error.response?.data?.message || 'An error occurred, please try again later.');
//       }

//       return Promise.reject(error);
//     }
//   );
// }

// public put<T = any>(url: string, data?: T) {
//   // if (data) {this.filterParams(data);}

//   return this.service.put(url, data);
// }

// public delete<T = any>(url: string, data?: T) {
//   // if (data) {this.filterParams(data);}

//   return this.service.delete(url, { data });
// }

// public post<T = any>(url: string, data?: T) {
//   // if (data) {this.filterParams(data);}

//   return this.service.post(url, data);
// }

// public get<T = any>(url: string, params?: T) {
//   // if (params) {this.filterParams(params);}

//   return this.service.get(url, { params });
// }

// private filterParams(params: Record<string, unknown>) {
//   for (const key in params) {
//     const val = params[key];
//     if (val && typeof val === 'object' && !Array.isArray(val)) {
//       this.filterParams(val as Record<string, unknown>);
//     } else if (val === null || val === undefined || (typeof val === 'string' && val.trim() === '')) {
//       delete params[key];
//     }
//   }
// }
// }

// const requestService = new RequestService();
// export default requestService;
